var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"images-view"},_vm._l((_vm.pictures),function(picture){return _c('div',{key:picture.coordinate,staticClass:"image-view-cell"},[_c('CoordinateImageView',{attrs:{"picture":picture}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }